import { IHistory } from './HistoryLog';
import { IRule } from './Rule';
import { IRemunerationCommission } from './RemunerationCommission';
import { IRemunerationBonus } from './RemunerationBonus';
import { IRemunerationFixed } from './RemunerationFixed';
import { IRemunerationGoal } from './RemunerationGoal';
import { IEPS } from './EPS';

export type RemunerationTypes = 'EXEMPTED' | 'COMMISSION' | 'VALUE_FIXED' | '';
export interface ISelectedEPS {
  epsId: IEPS | string;
  id: string;
  companyName: string;
  fantasyName: string;
  distributionPercentage: number;
  remunerationType: RemunerationTypes;
  remunerationCommissionId?: IRemunerationCommission;
  remunerationBonusId?: IRemunerationBonus;
  remunerationFixedIds?: IRemunerationFixed[];
  remunerationGoalIds?: IRemunerationGoal[];
}

export interface ISelectedEPSField {
  [epsId: string]: IPossiblyDraftSelectedEPS;
}

export interface IRange {
  min?: number;
  max?: number;
}

export enum AggregationTypeEnum {
  contract = 'CONTRACT',
  customer = 'CUSTOMER',
}

export enum CorporateTypeEnum {
  intercompany = 'INTERCOMPANY',
  atacado = 'ATACADO',
  corporativo = 'CORPORATIVO',
  empresarial = 'EMPTY',
}

export enum PropensityEnum {
  alta_propensao = 'ALTA_PROPENSAO',
  baixa_propensao = 'BAIXA_PROPENSAO',
  media_propensao = 'MEDIA_PROPENSAO',
  nao_aplicavel = 'NAO_APLICAVEL',
  nao_avaliado = 'NAO_AVALIADO',
  nao_propenso = 'NAO_PROPENSO',
}

export interface IMailingRule {
  _id: string;
  id: string;
  serviceCategory: { _id: string; description: string };
  name: string;
  aggregationType: AggregationTypeEnum;
  rules: IRule[];
  permanenceInDays?: number;
  permanenceUntilDate?: string;
  paymentRemunerationDays: number;
  weekDaysToExecute: number[];
  debtsDistribution: string;
  invoiceAgingToInclude?: IRange;
  periodUpdateDebt: number;
  collectRuleStrategies: ISelectedEPS[];
  status: 'CREATED' | 'ACTIVE' | 'INACTIVE' | 'DRAFT';
  dateStatus?: Date;
  history: IHistory[];
  statusChanges: string[];
}

export interface IPossiblyDraftSelectedEPS {
  epsId: IEPS | string;
  id?: string;
  companyName?: string;
  fantasyName?: string;
  distributionPercentage?: number;
  remunerationType: '' | 'EXEMPTED' | 'COMMISSION' | 'VALUE_FIXED';
  remunerationCommissionId?: string;
  remunerationBonusId?: string;
  remunerationFixedIds?: string[];
  remunerationGoalIds?: string[];
}

export interface IPossiblyDraftMailingRule {
  _id: string;
  id: string;
  serviceCategory?: string;
  name: string;
  aggregationType?: string;
  rules: IRule[];
  permanenceInDays?: number;
  permanenceUntilDate?: string;
  paymentRemunerationDays?: number;
  weekDaysToExecute?: number[];
  debtsDistribution?: string;
  invoiceAgingToInclude?: IRange;
  periodUpdateDebt?: number;
  collectRuleStrategies: IPossiblyDraftSelectedEPS[];
  status: 'CREATED' | 'ACTIVE' | 'INACTIVE' | 'DRAFT';
  history?: IHistory[];
}

export interface ISystemField {
  [systemName: string]: string[];
}

export interface IExpandedMailingRule {
  _id: string;
  id: string;
  serviceCategory: string;
  name: string;
  aggregationType: AggregationTypeEnum;
  customerAging?: IRange;
  shouldFilterOnContractAging: boolean;
  contractAging?: IRange;
  customerType: string[];
  corporateType: string[];
  propensity: string[];
  systems: ISystemField;
  billingType: string[];
  uf: string[];
  excludeExemption: boolean;
  activeOffer: string[];
  customerDebtsSum?: IRange;
  contractDebtsSum?: IRange;
  invoiceDebtAmount?: IRange;
  customerContractsSum?: IRange;
  contractInvoicesSum?: IRange;
  permanenceType: '' | 'permanenceInDays' | 'permanenceUntilDate';
  permanenceInDays: number;
  permanenceUntilDate: string;
  paymentRemunerationDays: number;
  weekDaysToExecute: number;
  debtsDistribution: string;

  shouldIncludeNewInvoice: boolean;
  invoiceAgingToInclude?: IRange;
  periodUpdateDebt: number;

  selectedEPS: ISelectedEPSField;
  status: 'CREATED' | 'ACTIVE' | 'INACTIVE' | 'DRAFT';
}
